import SortIndexNewRequest from '../../../../Spirit/Common/Helpers/Models/SortIndexNewRequest';

export default class ChangeSortIndexNewRequest  {
	SortIndices: Array<SortIndexNewRequest> = null;
	constructor(obj?: Partial<ChangeSortIndexNewRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
